export const SvgStar = () => (
  <svg
    style={{ display: 'block', flex: '0 0 auto' }}
    xmlns="http://www.w3.org/2000/svg"
    id="emoji"
    viewBox="0 0 72 72"
    width={50}
  >
    <g id="color">
      <polygon
        fill="#FCEA2B"
        stroke="none"
        points="35.9704,6.0368 27.7688,22.6704 9.4169,25.3441 22.702,38.2843 19.5737,56.5642 35.9859,47.928 52.4045,56.552 49.2626,38.2744 62.5382,25.3244 44.1842,22.6643"
      />
      <polygon
        fill="#FCEA2B"
        stroke="none"
        points="14.1635,41.4594 4.8592,42.0365 6.4763,46.7329"
      />
      <polygon
        fill="#FCEA2B"
        stroke="none"
        points="57.8365,40.9794 67.1408,41.5565 65.5237,46.2529"
      />
      <polygon
        fill="#FCEA2B"
        stroke="none"
        points="22.0721,15.5917 18.648,6.9211 14.6811,9.9103"
      />
      <polygon
        fill="#FCEA2B"
        stroke="none"
        points="50.4002,16.0862 57.9849,10.6662 54.1248,7.5403"
      />
      <polygon
        fill="#FCEA2B"
        stroke="none"
        points="35.9197,56.9779 33.4362,65.9632 38.4032,65.9632"
      />
    </g>
    <g id="hair" />
    <g id="skin" />
    <g id="skin-shadow" />
    <g id="line">
      <polygon
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        points="35.9248,6.0368 27.7233,22.6704 9.3713,25.3441 22.6564,38.2843 19.5282,56.5642 35.9403,47.928 52.3589,56.552 49.2171,38.2744 62.4926,25.3244 44.1387,22.6643"
      />
      <polygon
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        points="35.932,56.9779 33.4484,65.9632 38.4155,65.9632"
      />
      <polygon
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        points="57.8156,41.0785 65.5937,46.2171 67.1286,41.4932"
      />
      <polygon
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        points="14.1758,41.4594 4.8714,42.0365 6.4885,46.7329"
      />
      <polygon
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        points="50.4125,16.0862 57.9972,10.6662 54.1371,7.5403"
      />
      <polygon
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        points="22.0843,15.5917 18.6602,6.9211 14.6934,9.9103"
      />
    </g>
  </svg>
)
